<div class="sam-margin scheduler-container">
   <kendo-scheduler
      [kendoSchedulerBinding]="events$ | async"
      [selectedDate]="selectedDate"
      [scrollTime]="selectedDate"
      [selectedViewIndex]="currentView$ | async"
      [showWorkHours]="showBusinessHours$ | async"
      (selectedViewIndexChange)="onViewIndexChange($event)"
   >
      <kendo-scheduler-day-view> </kendo-scheduler-day-view>

      <kendo-scheduler-week-view> </kendo-scheduler-week-view>

      <kendo-scheduler-month-view> </kendo-scheduler-month-view>

      <kendo-scheduler-agenda-view></kendo-scheduler-agenda-view>
   </kendo-scheduler>
</div>
